import { serializeSortQueryParam } from "@/lib/utils";
import {
  getQuestionnaireResultsReport,
  QuestionnaireResultsReportRequestParams,
} from "@/requests/reports/questionnaire-results-report.request";
import { useQuery } from "@tanstack/react-query";

export const useQuestionnaireResultsReport = (
  params: QuestionnaireResultsReportRequestParams,
  enabled = true,
) => {
  return useQuery({
    queryKey: [
      "companies",
      params.companyId,
      "reports",
      "questionnaires",
      "results",
      {
        editionId: params.editionId,
        years: params.years,
        size: params.size,
        sort: serializeSortQueryParam(params.sort),
      },
    ],
    queryFn: () => getQuestionnaireResultsReport(params),
    enabled: !!params.companyId && enabled,
  });
};
